
<span class="icc-form-field-wrapper">
  <span class="icc-form-field-frame">
    <ng-content></ng-content>
  </span>
</span>